import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../pages/css/PhoneNumberList.css';
import banner from '../images/Hrias-b2b-banner.png';
import verifiedPhone from '../images/Hrias-phone-verified.png'
import phoneConnect from '../images/Hrias-phone-connect.png';
import icon1 from '../images/Hrias-phone-icon1.png'
import icon2 from '../images/Hrias-phone-icon2.png';
import icon3 from '../images/Hrias-phone-icon3.png';
import b2bcrm from '../images/Hrias-b2b-CRM.png';
import phoneMultiple from '../images/Hrias-phone-multiple.png';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTFour from '../images/Google.png';
import dashImg from '../images/Hrias-Phone-dash.jpg';

function PhoneNumberListB2C() {
    return (
        <div className="phone-list-page">

            {/* ===== Hero Section ===== */}
            <section
                className="hero-section text-center text-white d-flex align-items-center justify-content-center"
                style={{
                    backgroundImage:
                        `url(${banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "40vh",
                }}
            >
                <div className="container" style={{ color: "#ffffff" }}>
                    <h1 className="fw-bold" style={{ color: "#275a8eff" }}>
                       Get real numbers, reach leads directly,  <span className="highlight" style={{ color: "#7102c1ff" }}>& convert 3x faster.</span>
                    </h1>
                    <p className="lead mt-3" style={{ color: "#890059ff" }}>
                        Access 100% verified, GDPR-compliant business phone numbers to supercharge your outreach.
                    </p>
                    <button
                        className="btn btn-primary mt-4"
                        style={{
                            backgroundColor: "#134373ff",
                            border: "none",
                            color: "#ffffffff",
                            fontWeight: "600",
                            borderRadius: "30px",
                            padding: "12px 30px",
                            transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dcff")}
                        onMouseOut={(e) => (e.target.style.backgroundColor = "#134373ff")}
                    >
                        Contact Sales
                    </button>
                </div>

            </section>

            <section>
                    <div className="container py-5">
                      <img
                        src={dashImg}
                        alt="Padded Container"
                        className="img-fluid rounded shadow-lg"
                      />
                    </div>
                  </section>

             <section className="container my-5 partner-section">
                    {/* Heading */}
                    <h5 className="text-center partner-heading">
                      Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
                    </h5>
            
                    {/* Logo Row */}
                    <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
                      <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
                      <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
                      <img src={cTThree} alt="Berkshire" className="partner-logo" />
                      <img src={cTFour} alt="Google" className="partner-logo" />
                      <img src={cTFive} alt="PwC" className="partner-logo" />
                      <img src={cTSix} alt="Microsoft" className="partner-logo" />
                    </div>
                  </section>


            <section className="accuracy-section py-5 bg-light">
                <div className="container text-center">
                    <h2 className="section-heading">Get more numbers, without compromising quality</h2>
                    <p className="text-muted mb-4">
                        Hrias uses advanced algorithms and real-time data validation, checking market’s best phone databases, one by one, until it gets you the most accurate lead's number. This means that you get maximum coverage and quality, for a fraction of the cost.
                    </p>
                    <img
                        src={verifiedPhone}
                        alt="Verification Process"
                        className="img-fluid rounded shadow"
                    />
                </div>
            </section>

            {/* ===== Section 2: Overview ===== */}
            <section className="overview-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h2 className="fw-bold mb-3">Connect with Real Decision-Makers</h2>
                            <p>
                                HRIAS provides access to a global directory of verified phone numbers, ensuring your
                                sales and marketing teams can reach the right contacts without wasted effort.
                            </p>
                        </div>
                        <div className="col-md-6 text-center">
                            <img src={phoneConnect} alt="Phone list" className="img-fluid rounded shadow" />
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== Section 3: Key Features ===== */}
            <section className="features-section py-5 bg-light">
                <div className="container text-center">
                    <h2 className="fw-bold mb-5">Why Choose Our Verified Numbers?</h2>
                    <div className="row" style={{ margin: 0 }}>
                        <div className="col-md-4 mb-4" style={{ padding: "0 10px" }}>
                            <div
                                className="feature-box shadow-sm h-100"
                                style={{
                                    overflow: "hidden",
                                    borderRadius: "10px",
                                }}
                            >
                                <img
                                    src={icon1}
                                    alt="Verified"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-md-4 mb-4" style={{ padding: "0 10px" }}>
                            <div
                                className="feature-box shadow-sm h-100"
                                style={{
                                    overflow: "hidden",
                                    borderRadius: "10px",
                                }}
                            >
                                <img
                                    src={icon2}
                                    alt="GDPR"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-md-4 mb-4" style={{ padding: "0 10px" }}>
                            <div
                                className="feature-box shadow-sm h-100"
                                style={{
                                    overflow: "hidden",
                                    borderRadius: "10px",
                                }}
                            >
                                <img
                                    src={icon3}
                                    alt="Global Reach"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* ===== Section 4: How It Works ===== */}
            <section
                className="process-section py-5"
                style={{
                    backgroundColor: "#275E76", // light gray background
                    width: "100%",
                }}
            >
                <div className="container text-center">
                    <h2 className="fw-bold mb-5" style={{ color: "#fff" }}>
                        How It Works
                    </h2>
                    <div className="row">
                        <div className="col-md-4 mb-4">
                            <div
                                className="process-step p-4 shadow-sm h-100"
                                style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                }}
                            >
                                <h5 style={{ color: "#275E76" }}>1. Define Your Target</h5>
                                <p style={{ color: "#555" }}>
                                    Select your preferred region, industry, or role to filter your contact list.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div
                                className="process-step p-4 shadow-sm h-100"
                                style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                }}
                            >
                                <h5 style={{ color: "#275E76" }}>2. Get Verified Numbers</h5>
                                <p style={{ color: "#555" }}>
                                    Our AI filters and verifies active phone numbers in real time.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div
                                className="process-step p-4 shadow-sm h-100"
                                style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                }}
                            >
                                <h5 style={{ color: "#275E76" }}>3. Start Outreach</h5>
                                <p style={{ color: "#555" }}>
                                    Export your leads or integrate directly with HRIAS CRM for instant calling.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* ===== Section 5: Two Image Boxes ===== */}
            <section className="two-box-section py-5 bg-light">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="image-box p-3 rounded shadow-sm h-100">
                                <h4 className="fw-bold mb-2">Keep leads’ numbers fresh across your stack</h4>
                                <p>Get verified direct dials and mobile numbers to connect with key people in minutes.</p>
                                <img src={b2bcrm} alt="Instant Access" className="img-fluid rounded mt-3" style={{ height: '520px', width: '1520px' }} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="image-box p-3 rounded shadow-sm h-100">
                                <h4 className="fw-bold mb-2">Reach warm leads via call or WhatsApp</h4>
                                <p>Want 80% more replies? Find verified phone numbers and follow up on WhatsApp or with a quick call - right when the lead is most likely to talk to you.</p>
                                <img src={phoneMultiple} alt="Custom Data" className="img-fluid rounded mt-3" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== Section 6: Credibility / Stats ===== */}
            <section className="stats-section py-5 text-center">
                <div className="container">
                    <h2 className="fw-bold mb-4">Trusted by Sales Teams Globally</h2>
                    <div className="row justify-content-center">
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">98%</h3>
                            <p>Accuracy Rate</p>
                        </div>
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">500K+</h3>
                            <p>Verified Numbers</p>
                        </div>
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">150+</h3>
                            <p>Countries Covered</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== Section 7: Call to Action ===== */}
            <section className="cta-section text-center py-5">
                <div className="container">
                    <h2 className="fw-bold mb-3 text-white">Start Accessing Verified Phone Numbers Today</h2>
                    <p className="mb-4">Boost your sales calls and connect faster with decision-makers using 100% verified data.</p>
                    <button className="btn btn-primary px-4 py-2">Contact Sales</button>
                </div>
            </section>

            <section className="container my-5 client-review-section">
                <div className="row align-items-center">
                    {/* Left side - client image */}
                    <div className="col-12 col-md-3 text-center">
                        <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZiPwNzz_t6AAyoIDTb2uFl1N8BEWhUzz-CQ&s" // replace with your client's photo
                            alt="Client"
                            className="client-img"
                        />
                    </div>

                    {/* Right side - review text */}
                    <div className="col-12 col-md-9">
                        <p className="client-review">
                            “HRIAS Verified Phone Number database helped our sales team reach real decision-makers faster.
                            The accuracy is outstanding — no more wasted dials or dead numbers.
                            It has truly optimized our outbound strategy and boosted conversions!”
                        </p>
                        <h3 className="client-name">Johansen Stark</h3>
                        <p className="client-position">CEO, Stark Industries.</p>

                    </div>
                </div>
            </section>

        </div>
    );
}

export default PhoneNumberListB2C;
